import _debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import {
    getWalletBalance,
    getAllUsers,
    postGiftCard
} from 'network/apis/gift-cards';

function useGiftCard({ role, uniqueId }) {
    const [loading, setLoading] = useState(false);
    const [wallet, setWallet] = useState(null);
    const [users, setUsers] = useState([]);
    const [isFetchingGc, setIsFetchingGc] = useState(false);
    const [gcError, setGcError] = useState(null);
    const [gcSuccessMsg, setGcSuccessMsg] = useState(null);
    const [gcOrderDetail, setGcOrderDetail] = useState(null);

    useEffect(() => {
        fetchWalletBalance();
        setLoading(true);
    }, [uniqueId]);

    function handleGcReset() {
        setGcSuccessMsg(null);
        setGcOrderDetail(null);
        setGcError(null);
        setIsFetchingGc(false);
    }

    function fetchWalletBalance() {
        getWalletBalance({ UniqeID: uniqueId, UserRole: 'StoreCP' })
            .then((res) => {
                
                setLoading(false);
                setWallet(res.data);
            })
            .catch((err) => {
                setLoading(false);
            });
    }

    function fetchUsers(searchKey) {
        getAllUsers({
            search_key: searchKey.toUpperCase(),
            search_by: 'ProfileUniqeID'
        })
            .then((res) => {
                setUsers(res.data.list);
            })
            .catch((err) => {
                setLoading(false);
            });
    }

    const purchaseGiftCard = _debounce(function (payload) {
        setGcError(null);
        setGcSuccessMsg(null);
        setGcOrderDetail(null);
        setIsFetchingGc(true);
        postGiftCard(payload)
            .then((res) => {
                setIsFetchingGc(false);
                fetchWalletBalance();
                setLoading(true);
                if (res.data.error) {
                    setGcError(res.data.error);
                } else {
                    setGcSuccessMsg(res.data.message);
                    setGcOrderDetail(res.data.orderDetail);
                    
                }
            })
            .catch((err) => {
                setIsFetchingGc(false);
                setGcError(err?.message);
            });
    }, 300);

    return {
        loading,
        isFetchingGc,
        gcSuccessMsg,
        gcOrderDetail,
        gcError,
        wallet,
        users,
        setWallet,
        fetchUsers,
        purchaseGiftCard,
        handleGcReset
    };
}

export default useGiftCard;
